exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".client-name {\n    font-size: 25px;\n    font-weight: bold;\n    margin-left: -275px;\n    margin-top: 87px;\n}\n\n.notes-massage .fa-times{\n\n}\n.notes-massage .fa-times{\n    opacity:0.8;\n    cursor:pointer;\n    font-size:15px;\n}\n.notes-massage .fa-times:hover{\n    opacity:1;\n}\n\nform.section {\n    margin-top: 35px;\n}\n\nhr {\n    margin-top: 10px;\n    margin-bottom: 15px;\n    border: 1px solid #eee;\n}\n\n.notes-info {\n    font-size: 13px;\n    margin-bottom: 5px;\n}\n\n.note-limit-height {\n    max-height: 600px;\n    overflow-y: auto;\n}\n\n.notes-massage {\n    margin-top: 8px;\n    margin-bottom: 12px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/notes/notes.component.css
// module id = 1213
// module chunks = 9